// extracted by mini-css-extract-plugin
export default {"button":"ForgetPass_button__HFgEF","logo":"ForgetPass_logo__dtRlY"};